import React from 'react';

export const TitleBar = React.memo(({ pageContent, affiliationData }) => {
	return (
		<div className='row mx-0 mt-3 container-fluid'>
			<h4>
				{pageContent.headingPreText ? pageContent.headingPreText : ''}{' '}
				{affiliationData.name}{' '}
				{pageContent.headingPostText ? pageContent.headingPostText : ''}
			</h4>
		</div>
	);
});
